const _ = require('lodash');
const { indexOf } = require('lodash');

import Alpine from 'alpinejs';
window.Alpine = Alpine;
Alpine.start();

require('bootstrap');
require('../gia-login-overlay');

global.$ = global.jQuery = require('jquery');


var _mmstart = 0;
var _ringRad = 350;
var _onmdown = false;
var _mdownobj = null;
var _filtersec;
var _loginredirect = '';
var diamond_list_total = 0;

function trace(...msg){
    if(['localhost', '127.0.0.1', 'stg.degemdiamond.com'].includes(location.hostname)){
        console.log(msg);
    }
}

function resetDiamondFlter(){
  filterNow();
}
function windowResize(){

  if( $('#ft-results').length > 0  ) {
    $('.twrap2').css('width', '');
    var ww = $('#ft-results table.resulthere thead tr th:last-child').innerWidth() + 0;

    if( $(window).innerWidth() < 500 ) ww = 0;
    $('#ft-results .preview-area-table').css('width', ww - 2);
    $('#cp-results .preview-area-table').css('width', ww - 2);
    $('#rv-results .preview-area-table').css('width', ww - 2);
    $('.gia-results table.resulthere').css('width',  $('#ft-results table.headonly').innerWidth() );

    $('.twrap2').css('width',  $('#ft-results table.headonly').innerWidth() - ww);
  }
/*
  if( $('.entext').length > 0 ){

    var s = 1;
    var s  = $('.entext').innerWidth() / 891;
    if( s > 1 ) s = 1;

    $('.entext').css('transform','scale('+s+')');

  }
  */
}


function loadResults(){
  //$("#ft-results").attr("data-loading",1);

  var page = parseInt($("#ft-results").attr("data-cpage")) + 1;
  //$("#ft-results").attr("data-cpage", page);
  giaFilterNow(page);
  /*
  setTimeout( function(){
    $("#ft-results").attr("data-loading",0);
  }, 3000 );
  */

}
$(document).ready( function(){

  if( $('#idFont').length > 0 ){
    $('input[name="txtFont"]').val( $('#idFont li a.checked').attr('data-value') );
    //$('.entext div').addClass( $('input[name="txtFont"]').val() );

    //$('.entext div').arctext({radius: _ringRad, dir: -1});



  }



  $('.giareport').click( function(e){
    e.preventDefault();

    $('.thumbs li:last-child a').click();
  });

  $('#btnAppointment').click( function(e){
    e.preventDefault();

    if( $(this).hasClass('dis') ) return;

    $(this).parent().find('.has-error').removeClass('has-error');
    $('.login-inner .err-msg').hide();

    var isOK = true;
    var obj = $('input[name="txtAPEmailAddress"]');
    if( !validateEmail(obj.val()) ) {
      isOK = false;
      obj.addClass('has-error');
    }

    obj = $('select[name="txtAPBoutique"]');
    if( obj.val() == "" ) {
      isOK = false;
      obj.addClass('has-error');
    }

    obj = $('input[name="txtAPName"]');
    if( obj.val().length < 3 ) {
      isOK = false;
      obj.addClass('has-error');
    }

    obj = $('input[name="txtAPContactNo"]');
    if( obj.val().length < 10 ) {
      isOK = false;
      obj.addClass('has-error');
    }

    obj = $('input[name="txtAPAddressPostcode"]');
    if( obj.val().length < 5 ) {
      isOK = false;
      obj.addClass('has-error');
    }

    obj = $('input[name="txtAPAppointmentDate"]');
    if( obj.val().length < 10 ) {
      isOK = false;
      obj.addClass('has-error');
    }

    var str = "";
    $('input[name="chkAPInterest[]"]:checked').each(function() {
      str += this.value + ",";
   });

   if( str.length != 0 ) str = str.substr(0, str.length - 1);


    if( !isOK ) return;

    $(this).addClass('dis');

    $.ajax(
      {
        method: "POST", url: "/api/appointment",
        data :{
          boutique: $('select[name="txtAPBoutique"]').val(),
          name: $('input[name="txtAPName"]').val(),
          email: $('input[name="txtAPEmailAddress"]').val(),
          contactno: $('input[name="txtAPContactNo"]').val(),
          postcode: $('input[name="txtAPAddressPostcode"]').val(),
          date: $('input[name="txtAPAppointmentDate"]').val(),
          message: $('textarea[name="txtAPMessage"]').val(),
          interest: str,
        },
        success: function (response) {
          $('.appointment-inner .greetings').hide();
         $('.appointment-inner .formarea').html('DeGem customer care will be in touch with you soon. <br><br>Thank you.');
        }
      });



  });

  $("#ft-results .twrap2").scroll(function() {
    var $this = $(this);
    var $results = $("#ft-results .twrap2 .resulthere");
    var offsettop = $results.css('margin-top');
    offsettop = offsettop.substr( 0, offsettop.length - 2);
    offsettop = parseFloat(offsettop) - 250;

    //console.log( ($this.scrollTop() + $this.height()) + " > " +  ($results.height() + offsettop) );
    if( $("#ft-results").attr("data-loading") == 0 ) {
        if ($this.scrollTop() + $this.height() > $results.height() + offsettop) {
            loadResults();
        }
    }
});




  $('.chkEngrave').click( function(e){
    e.preventDefault();
    $('.engraving-details').removeClass('show');
    if( !$(this).hasClass('checked') ) $('.engraving-details').addClass('show');
  });

  $('.buydiamond').click( function(e){
    e.preventDefault();
    $('#frm').submit();
  });

  $('.doption a').click( function(e){

    $('.opts').attr('class','opts');
    $('input[name="txtDeliveryOption"]').val( $(this).attr('data-id') );
    $('.opts').addClass('opt' + $(this).attr('data-id'));

  });


  if( $('#ePayment').length > 0  ){
    $('#ePayment').submit();
  }

  $('#btnUpdRP').click( function(e){
    e.preventDefault();
    $('#frm').submit();
  });

  $('#btnResetPassword').click( function(e){
    e.preventDefault();

    if( $(this).hasClass('dis') ) return;

    $(this).parent().find('.has-error').removeClass('has-error');
    $('.login-inner .err-msg').hide();

    var isOK = true;
    var obj = $('input[name="txtFPEmail"]');
    if( !validateEmail(obj.val()) ) {
      isOK = false;
      obj.addClass('has-error');
    }

    if( !isOK ) return;

    $(this).addClass('dis');

    $.ajax(
      {
        method: "POST", url: "/api/forgetpassword",
        data:{
          email: $('input[name="txtFPEmail"]').val()
        },
        success: function (response) {
          $('.forgotpassword-inner .err-msg').show();
          $('#btnResetPassword').removeClass('dis');
        }
      });


  });


    $('#btnPayNow').click( function(e){
      e.preventDefault();
      $('#frm').submit();
    });

    $('#btnMobileMenu').click( function(e){
      e.preventDefault();
      $('body').toggleClass('mobilemenu');
    });

    $('a.closemenu').click( function(e){
      e.preventDefault();
      $('body').toggleClass('mobilemenu');
    });


  $('div.currency-selector span').click( function(e){
    e.preventDefault();
    $(this).parent().toggleClass('expand');
  });

  $('div.currency-selector div.dd a').click( function(e){
    e.preventDefault();
    $('div.currency-selector').removeClass('expand');

    $.ajax(
      {
        method: "POST", url: "/api/currency",
        data :{
          currency: $(this).attr('href').substr(1)
        },
        success: function (response) {
          window.location.reload();
        }
      });

  });

  $('.address-container .address-box2 a.icoRemove').click( function(e){
    e.preventDefault();
    $('input[name="txtUAID"]').val( $(this).attr('data-id') );
    $('#frm').submit();
  });

  $('#btnUpdateAcc').click( function(e){
    e.preventDefault();

    $(this).parent().find('.has-error').removeClass('has-error');
    //$('.err-msg').hide();


    var isOK = true;
    var obj = $('input[name="txtAccFirstName"]');
    if( obj.val().length < 1 ) {
      isOK = false;
      obj.addClass('has-error');
    }
    obj = $('input[name="txtAccLastName"]');
    if( obj.val() < 1 ) {
      isOK = false;
      obj.addClass('has-error');
    }

    obj = $('input[name="txtAccContactNumber"]');
    if( obj.val().length < 9 ) {
      isOK = false;
      obj.addClass('has-error');
    }

    obj = $('input[name="txtAccDOB"]');
    if( obj.val().length != 10 ) {
      isOK = false;
      obj.addClass('has-error');
    }


    if( $('.changepwd').is(':visible') ){
      obj = $('input[name="txtAccPassword0"]');
      if( obj.val().length < 8 ) {
        isOK = false;
        obj.addClass('has-error');
      }


      obj = $('input[name="txtAccPassword"]');
      var obj2 = $('input[name="txtAccPassword2"]');
      if( obj.val() < 8 || obj.val() != obj2.val() ) {
        isOK = false;
        obj.addClass('has-error');
        obj2.addClass('has-error');
      }
    }

    if( !isOK ) return;
    var newsletter = 0;
    if( $('.account-details .chkNewsletter').hasClass('checked') ) newsletter = 1;
    $('input[name="txtNewsletter"]').val( newsletter );

    $('#frm').submit();
  });


  $('a.btnChagnePwd').click( function(e){
    e.preventDefault();
    $(this).hide();
    $('.changepwd').show();
    $('input[name="txtChangePWD"]').val(1);
  });

  $('a.btnChagnePwd2').click( function(e){
    e.preventDefault();
    $('a.btnChagnePwd').show();
    $('.changepwd').hide();
    $('input[name="txtChangePWD"]').val(0);
  });

var curyear = new Date().getFullYear();


  $( ".datepicker" ).datepicker( {
    changeMonth: true,
    changeYear: true,
    yearRange: (curyear - 90) + ":" + (curyear ),
    minDate:"-100Y",
    maxDate: +1,
  } );

  $( ".datepicker2" ).datepicker( {
    //changeMonth: true,
    //changeYear: true,
    //yearRange: (curyear - 90) + ":" + (curyear )
    minDate:+1,
    maxDate: "+1M"
  } );



  $('.tooltipchanger a').click( function(e){
    e.preventDefault();
    var par = $(this).parent().parent().parent();
    par.find('.active').removeClass('active');
    par.find('.img--' + $(this).attr('href').substr(1) ).addClass('active');
    par.find('.desc--' + $(this).attr('href').substr(1) ).addClass('active');
    $(this).addClass('active');
  });

  $('.addToFav').click( function(e){
    e.preventDefault();
    $(this).toggleClass('active');
    var a = $(this).attr('data-ref').split("|");
    var state = 0;
    if( $(this).hasClass('active') ) state = 1;

      $.post("/api/wishlist",
      {
        type:a[0],
        id:a[1],
        state: state
      });
  });

  $.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});


$('#btnPlaceOrder').click( function(e){
  e.preventDefault();
  if( $(this).hasClass('dis') ) return;
  $('#shipaddress').removeClass('err');

  var allok = true;


  if( $('input[name="txtDeliveryOption"]').val() == 'P' )
  {
    if( $('input[name="txtPickupID"]').val() == '' ){
      allok = false;
      $('#pickupaddress').addClass('err');
    }
  }else{
    if( $('input[name="txtShippingAddress"]').val() == '' ){
      allok = false;
      $('#shipaddress').addClass('err');
    }
  }

  if( $('input[name="txtBillingAddress"]').val() == '' ){
    allok = false;
    $('#billaddress').addClass('err');
  }

  if( allok ){
  $(this).addClass('dis');
  $('#frm').submit();
  }

});

$('.wishlist-page a.closeButton').click( function(e){
  e.preventDefault();
  $('input[name="txtRefCode"]').val( $(this).attr('data-ref') );
  $('#frm').submit();

});


$('.editaddress').click( function(e){
      e.preventDefault();
      $('body').addClass('address-overlay');
      $('.address-overlay-div .inner-box' ).hide();
      $('.address-overlay-div .err-msg').hide();

      $('.new-address-inner input').val('');

      var secc = $(this).attr('data-sec');

      if( $(this).attr('data-sec') == 'select-address' ){
        $('.select-address-inner h6').html( $(this).attr('data-title') );
        $('.select-address-inner ul a').removeClass('checked');

        if( $('.select-address-inner ul li:first-child').hasClass('noaddress') ){
          secc = 'new-address';
        }
      }

      $('.address-overlay-div .inner-box.'+secc+'-inner' ).show();






});



$('nav ul.right-icons li a, a.loginact').click( function(e){
    if($(this).data('sec')=='appointment'){
        e.preventDefault();
        window.location.href = '/make-an-appointment';
        return true;
    }

    if( $(this).attr('data-validate') == 1 ){
      if( $(this).attr('data-logined') == 0 ){
        e.preventDefault();

        _loginredirect = '';
        $('body').addClass('login-overlay');
        $('.login-overlay-div .inner-box' ).hide();
        $('.login-overlay-div .err-msg').hide();
        $('.login-overlay-div .inner-box.'+$(this).attr('data-sec')+'-inner' ).show();

        if( $(this).attr('data-redirect') )_loginredirect = $(this).attr('data-redirect');
      }
    }
});

  $('#btnNewAdd2').click( function(e){
    e.preventDefault();
    if( $(this).hasClass('dis') )return;

    $(this).parent().find('.has-error').removeClass('has-error');
    $('.new-address-inner .err-msg').hide();
    var isOK = true;
    var obj = $('input[name="txtAdd2Name"]');
    if( obj.val().length < 1 ) {
      isOK = false;
      obj.addClass('has-error');
    }
    obj = $('input[name="txtAdd2Contact"]');
    if( obj.val() < 10 ) {
      isOK = false;
      obj.addClass('has-error');
    }

    obj = $('input[name="txtAdd2Line1"]');
    if( obj.val().length < 1 ) {
      isOK = false;
      obj.addClass('has-error');
    }

    obj = $('input[name="txtAdd2Postcode"]');
    if( obj.val().length < 5 ) {
      isOK = false;
      obj.addClass('has-error');
    }
    obj = $('input[name="txtAdd2City"]');
    if( obj.val().length < 1 ) {
      isOK = false;
      obj.addClass('has-error');
    }
    if( !isOK ) return;

    $(this).addClass('dis');

    $('input[name="txtAdd2Default"]').val( ($('.chkDefault.checked').length > 0 ? 1 : 0) );

    $('#frm').submit();
  });


  $('#btnNewAdd').click( function(e){
    e.preventDefault();

    if( $(this).hasClass('dis') )return;

    $(this).parent().find('.has-error').removeClass('has-error');
    $('.new-address-inner .err-msg').hide();
    var isOK = true;
    var obj = $('input[name="txtAddName"]');
    if( obj.val().length < 1 ) {
      isOK = false;
      obj.addClass('has-error');
    }
    obj = $('input[name="txtAddContact"]');
    if( obj.val() < 5 ) {
      isOK = false;
      obj.addClass('has-error');
    }

    obj = $('input[name="txtAddLine1"]');
    if( obj.val().length < 1 ) {
      isOK = false;
      obj.addClass('has-error');
    }

    obj = $('input[name="txtAddPostcode"]');
    if( obj.val().length < 4 ) {
      isOK = false;
      obj.addClass('has-error');
    }
    obj = $('input[name="txtAddCity"]');
    if( obj.val().length < 1 ) {
      isOK = false;
      obj.addClass('has-error');
    }
    if( !isOK ) return;

    $(this).addClass('dis');

    $.ajax(
      {
        method: "POST", url: "/api/address/new",
        data :{
          name: $('input[name="txtAddName"]').val(),
          contact: $('input[name="txtAddContact"]').val(),
          line1: $('input[name="txtAddLine1"]').val(),
          line2: $('input[name="txtAddLine2"]').val(),
          line3: $('input[name="txtAddLine3"]').val(),
          postcode: $('input[name="txtAddPostcode"]').val(),
          city: $('input[name="txtAddCity"]').val(),
          state_text:$('input[name="txtAddState"]').val(),
          state_id: 0,
          country_id: $('select[name="txtAddCountry"]').val(),
        },
        success: function (response) {

          $('#btnNewAdd').removeClass('dis');
          if( response.status == 1 ) {
            $('body').removeClass('info-overlay login-overlay address-overlay');
            var html = '<b>'+response.data.name+'</b>';
            html += '<p>'+response.data.line1 + '<br>';

            if( response.data.line2 != null )
              html += response.data.line2 + '<br>';

              if( response.data.line3 != null )
                html += response.data.line3 + '<br>';

            html += response.data.postcode + ' ' + response.data.city+ '<br>';
            //html += response.data.state_text + '<br>';
            html += response.data.country_text + '<br>';
            html += 'Contact No. : '+ response.data.contact + '</p>';

            if( $('.select-address-inner h6').html() == "Billing Address" ){
              $('input[name="txtBillingAddress"]').val( response.data.id );
              $('#billaddress').html(html);
              $('#billaddress').removeClass('err');
            }
            else{
              $('input[name="txtShippingAddress"]').val( response.data.id );
              $('#shipaddress').html(html);
              $('#shipaddress').removeClass('err');
            }

            //var html = par.find('ul li a.checked').html().replace("<i></i>","");

            var html3 = '<li><a href="#" class="checkbox" data-single="1" data-id="'+response.data.id+'"><i></i>'+html+'</a><li>';

            if( $('.select-address-inner ul li:first-child').hasClass('noaddress') ){
              $('.select-address-inner ul li:first-child').remove();
            }

            $('.select-address-inner ul').append(html3);

            $('a.checkbox').off( "click", function(e){
              e.preventDefault();

              if( $(this).attr('data-single') == 1 ){
                $(this).parent().parent().find('.checked').removeClass('checked');
                $(this).addClass('checked');
              }
              else
                $(this).toggleClass('checked');
            });
            $('a.checkbox').on( "click", function(e){
              e.preventDefault();

              if( $(this).attr('data-single') == 1 ){
                $(this).parent().parent().find('.checked').removeClass('checked');
                $(this).addClass('checked');
              }
              else
                $(this).toggleClass('checked');
            });

            $('a.baddressbtn').html('Change');
            $('.noteaddresss').html('Please select an address.');


            // ---- SAI 20240611
            setTimeout(function(){
                updateShippingFeeDisplay(response.data.id);
            }, 500);

          }
          else {
            //err msg
          }
        }
      });
  });

  $('#btnSelAdd').click( function(e){
    e.preventDefault();

    var par = $(this).parent();
    if( par.find('ul li a.checked').length == 1 ){

      $('body').removeClass('info-overlay login-overlay address-overlay');
      var html = par.find('ul li a.checked').html().replace("<i></i>","");

      if( $('.select-address-inner h6').html() == "Billing Address" ){
        $('#billaddress').html(html);
        $('#billaddress').removeClass('err');
        $('input[name="txtBillingAddress"]').val( par.find('ul li a.checked').attr('data-id') );
      }else{
        $('#shipaddress').html(html);
        $('#shipaddress').removeClass('err');
        $('input[name="txtShippingAddress"]').val( par.find('ul li a.checked').attr('data-id') );
        //console.log(html)
        updateShippingFeeDisplay($('input[name="txtShippingAddress"]').val());
      }

    }

  });


  $('#btnSelAdd2').click( function(e){
    e.preventDefault();

    var par = $(this).parent();
    if( par.find('ul li a.checked').length == 1 ){

      $('body').removeClass('info-overlay login-overlay address-overlay');
      var html = par.find('ul li a.checked').html().replace("<i></i>","");
      $('#pickupaddress').html(html);
      $('#pickupaddress').removeClass('err');
      $('input[name="txtPickupID"]').val( par.find('ul li a.checked').attr('data-id') );

      console.log(html)
      resetShippingFee()

    }

  });

  $('#btnCreateAcc').click( function(e){
    e.preventDefault();
    if( $(this).hasClass('dis') ) return;

    $(this).parent().find('.has-error').removeClass('has-error');
    $('.register-inner .err-msg').hide();
    var isOK = true;
    var obj = $('input[name="txtRegFirstName"]');
    if( obj.val().length < 1 ) {
      isOK = false;
      obj.addClass('has-error');
    }
    obj = $('input[name="txtRegLastName"]');
    if( obj.val() < 1 ) {
      isOK = false;
      obj.addClass('has-error');
    }

    obj = $('input[name="txtRegDOB"]');
    if( obj.val().length != 10 ) {
      isOK = false;
      obj.addClass('has-error');
    }

    obj = $('input[name="txtRegContact"]');
    if( obj.val().length < 9 ) {
      isOK = false;
      obj.addClass('has-error');
    }

    obj = $('input[name="txtRegEmail"]');
    if( !validateEmail(obj.val()) ) {
      isOK = false;
      obj.addClass('has-error');
    }
    obj = $('input[name="txtRegPassword"]');
    var obj2 = $('input[name="txtRegPassword2"]');
    if( obj.val().length < 8 || obj.val() != obj2.val() ) {
      isOK = false;
      obj.addClass('has-error');
      obj2.addClass('has-error');
    }

    if( !isOK ) return;

    $(this).addClass('dis');

    var dob = $('input[name="txtRegDOB"]').val();
    var dobarr = dob.split('-');
    console.log('dob', dob,dobarr[0].length);
    if(dobarr[0].length!=4){
        dob = dob.substr(-4) + "-" + dob.substr(0,2) + "-" + dob.substr(3,2);
    }
    $.ajax(
      {
        method: "POST", url: "/api/register",
        data :{
          first_name: $('input[name="txtRegFirstName"]').val(),
          last_name: $('input[name="txtRegLastName"]').val(),
          email: $('input[name="txtRegEmail"]').val(),
          contact_number: $('input[name="txtRegContact"]').val(),
          dob: dob,
          password: $('input[name="txtRegPassword"]').val(),
          password_confirmation: $('input[name="txtRegPassword2"]').val(),
          newsletter: ($('.chkNewsletter.checked').length > 0 ? 1 : 0),
        },
        success: function (response) {
          if( response.status == 1 ) window.location.reload();
          else $('#btnCreateAcc').removeClass('dis');
        },
        error: function (response) {
          $('.register-inner .err-msg').show();
          var obj = $('input[name="txtRegEmail"]');
          obj.addClass('has-error');

          $('#btnCreateAcc').removeClass('dis');
        }
      });
  });

  $('#btnLogin').click( function(e){
    e.preventDefault();

    if( $(this).hasClass('dis') ) return;

    $(this).parent().find('.has-error').removeClass('has-error');
    $('.login-inner .err-msg').hide();

    var isOK = true;
    var obj = $('input[name="txtLoginEmail"]');
    if( !validateEmail(obj.val()) ) {
      isOK = false;
      obj.addClass('has-error');
    }

    obj = $('input[name="txtLoginPassword"]');
    if( obj.val() == "" ) {
      isOK = false;
      obj.addClass('has-error');
    }

    if( !isOK ) return;

    $(this).addClass('dis');

    $.ajax(
      {
        method: "POST", url: "/api/login",
        data :{
          email: $('input[name="txtLoginEmail"]').val(),
          password: $('input[name="txtLoginPassword"]').val()
        },
        success: function (response) {
          if( response.status == 1 ) window.location.reload();
          else {
            $('.login-inner .err-msg').show();
            $('#btnLogin').removeClass('dis');
          }
        }
      });
  });


  $('.cart-page a.icoRemove').click( function(e){
    e.preventDefault();
    $('input[name="txtRefCode"]').val( $(this).attr('data-code') );
    $('input[name="txtAction"]').val( $(this).attr('data-act') );
    $('#frm').submit();
  });

  $('a.checkbox').on( "click", function(e){
    e.preventDefault();

    if( $(this).attr('data-single') == 1 ){
      $(this).parent().parent().find('.checked').removeClass('checked');
      $(this).addClass('checked');
    }
    else
      $(this).toggleClass('checked');
  });

  $('.toggleUL').click( function(e){
    e.preventDefault();

    $(this).toggleClass('expanded');

    $(this).parent().find('ul').removeClass('expanded');
    if( $(this).hasClass('expanded') ){
      $(this).parent().find('ul').addClass('expanded');
    }
  });

  $('.info-overlay').click( function(e){
    $('body').addClass('info-overlay');
    $('.info-overlay-div .overlay-content' ).hide();
    $('.overlay-content#' + $(this).attr('data-overlay') ).show();
  });


  $('.login-overlay-div a.closeButton, .info-overlay-div a.closeButton, .address-overlay-div a.closeButton').click( function(e){
    $('body').removeClass('info-overlay login-overlay address-overlay');
  });

  $('.expandfilter a').click( function(e){
    e.preventDefault();

    $(this).parent().parent().toggleClass('expandfilters');
  });

  $('.gia-results .tabs ul li a').click( function(e){
    e.preventDefault();
    $(this).parent().parent().find('.active').removeClass('active');
    $(this).addClass('active');

    var id = $(this).attr('href');
    $('.gia-results #ft-results, .gia-results #rv-results, .gia-results #cp-results').removeClass('visi');
    $('#' + id).addClass('visi');


    if( id == "rv-results" ){
      getGIARecentViews();
    }

  });

    $('ul.ico-group li a').click( function(e){
      e.preventDefault();
      $(this).toggleClass('active');

      var shape = "icoDiamond2" + $(this).find('span').html();
      $(this).find('i').removeClass(shape);
      if( !$(this).hasClass('active') ) $(this).find('i').addClass(shape);

      //filterNow();
    });

    $('ul.box-group li a').click( function(e){
      if( $(this).parent().parent().attr('data-type') == 'link' ){

      }
      else{
        e.preventDefault();
        $(this).toggleClass('active');
        //filterNow();
      }
    });

    if( $('.ring-details').length > 0 ){

        $('#idRingSize').change( function(e){
          e.preventDefault();
          var p = $(this).parent().find('select option:selected').attr('data-price');
          $('#idPriceHolder').html( p );
        });

        $('.btnAddtoBag').click( function(e){
          e.preventDefault();
          $('.has-error').removeClass('has-error');
          var isOK = true;

if( $('.chkEngrave').hasClass('checked') ){
          var obj = $('input[name="txtEngraveText"]');
          if( obj.val() == "" ){

            obj.parent().addClass('has-error');
            isOK = false;
          }

          var obj = $('#idFont');
          if( obj.find('a.checked').length == 0 ){
            obj.parent().addClass('has-error');
            isOK = false;
          }
        }
        else{
          $('input[name="txtFont"]').val( 0 );
          $('input[name="txtEngraveText"]').val('');
          $('.engraving-details').find('.has-error').removeClass('has-error');
        }

          if( isOK ) {
            $('#frm').submit();
          }

        });

        $('#idFont a').click( function(e){
          e.preventDefault();

          $(this).parent().parent().find('.checked').removeClass('checked');
          $(this).addClass('checked');

          $('input[name="txtFont"]').val( $(this).attr('data-value') );

          //$('.entext').attr('class','entext');
          //$('.entext').addClass($(this).attr('data-value'));
        });


        $('input[name="txtEngraveText"]').on( 'keyup', function(){
          var str = $(this).val();
          if( str == "") str = "Degem";
          $('#idFont span').html( str );

          var cs = $('input[name="txtFont"]').val();

          //$('.entext').attr('class','entext');
          //$('.entext').addClass(cs);
          //$('.entext').html( "<div>" + str + "</div>" );

          //$('.entext div').arctext({radius: _ringRad, dir: -1});


        });

    }
    if( $('#sldPrice').length > 0 ) {
      $('#sldPrice').dgSlider();
    }

    if( $('.gia-diamond-filters').length > 0 && !$('.gia-diamond-filters').hasClass('gia-details') ){


      if( !$('.gia-diamond-filters').hasClass('ring-setting') ){

        $('#ft-results thead a.sortfield').click( function(e){
          e.preventDefault();

          var par = $(this).parent().parent();

          if( $(this).hasClass('active') ){

            $(this).toggleClass('up');
          }else{
            par.find('.up').removeClass('up');
            par.find('.active').removeClass('active');

            $(this).addClass('up active');
          }

          filterNow();
        });



        $('#rv-results thead a.sortfield, #cp-results thead a.sortfield').click( function(e){
          e.preventDefault();

          var par = $(this).parent().parent()


          if( $(this).hasClass('active') ){

            $(this).toggleClass('up');
          }else{
            par.find('.up').removeClass('up');
            par.find('.active').removeClass('active');

            $(this).addClass('up active');
          }

          sortCompareBox('#' + $(this).parent().parent().parent().parent().parent().parent().attr('id') );
        });

        $('#sldClarity').dgSlider();
        $('#sldSize').dgSlider();
        //$('#sldPrice').dgSlider();
        $('#sldColor').dgSlider();
        $('#sldCut').dgSlider();
        $('#sldTable').dgSlider();
        $('#sldDepth').dgSlider();

        $('#sldFluorescence').dgSlider();
        $('#sldSymmetry').dgSlider();
        $('#sldPolish').dgSlider();

        $('#btncheck').click( function(e){
          e.preventDefault();
        });



        /*
        var $table = $('#ft-results div.twrap table');
        $table.floatThead({
          scrollContainer: function($table){
                return $table.closest('div.twrap');
            }
        });
        */


      }
      else{

      }

    }

    //filterNow();



/*
    $('select[name="shape"], select[name="cut"], select[name="color"], select[name="clarity"], select[name="symmetries"], select[name="fluorescences"]').change( function(e){
      clearTimeout(_filtersec);
      _filtersec = setTimeout( filterNow, 500 );
    });
    */

    if( $('.gia-detail').length > 0 ){


      $('.gia-detail .thumbs li a').click( function(e){
        e.preventDefault();

        $(this).parent().parent().find('.active').removeClass('active');

        $(this).addClass('active');

        var src = $(this).attr('href');
        var type = $(this).attr('data-type');

        var html = '<div>';

        if( type =='img' ){
          html += '<img src=\''+src+'\' alt=\'\' />';

          if( $(this).attr('data-engrave') == 1 ){
            //var txt = $('input[name="txtEngraveText"]').val();
            //if( txt == "" ) txt = "Degem";
            //html += '<div class="entext '+$('input[name="txtFont"]').val()+'"><div>'+txt+'</div></div>';

            //var s = 1;
            //var s  = $('.entext').innerWidth() / 891;
            //if( s > 1 ) s = 1;
            //$('.entext').css('transform','scale('+s+')');

          }


        }else if( type =='vid2' ){
          html += '<div id="ss" ></div>';
        }else if( type =='vid' ){
          html += '<iframe src=\''+src+'\' scrolling=\'no\' ></iframe>';
        }else if( type =='pdf' ){
          html += '<iframe src=\''+src+'\' scrolling=\'no\' ></iframe>';
        }

        html += '</div>';
        $('.gia-detail .preview-inner').html( html );

        //if( $(this).attr('data-engrave') == 1 ){
          //$('.entext div').arctext( {radius: _ringRad, dir: -1});
        //}

        if( type =='vid2' ){

          var total = parseInt($(this).attr('data-frames'));
          var i;
          var sc = [];

          for( i=1; i<=total; i++ ){
            var str = "000" + i;
            str = str.substr(-3);
            sc.push( src + str + ".png" );
          }

          $("#ss").spritespin({
            // path to the source images.
            retainAnimate: true,
            source: sc,
            responsive:true,
            width   : 1000,  // width in pixels of the window/frame
            height  : 1000,  // height in pixels of the window/frame
          });
        }

      });
    }

    $('.reset-filter').click( function(e){
      e.preventDefault();
      if( !$('.gia-diamond-filters').hasClass('ring-setting') ){

        $('#idShape li a').removeClass('active');
        //$('#idShape li:first-child a').addClass('active');
        $('#idShape li').each( function(n,e){

          var str = $(this).find('a').attr('href');
          $(this).find('a i').removeClass('icoDiamond2' + str);
          if( n > 0 ) {
            $(this).find('a i').addClass('icoDiamond2' + str);
          }else{
            $(this).find('a').addClass('active');
          }
        });

        $('#sldPrice').dgSlider('reset');
        $('#sldClarity').dgSlider('reset');
        $('#sldColor').dgSlider('reset');
        $('#sldCut').dgSlider('reset');
        $('#sldSize').dgSlider('reset');

        $('#sldFluorescence').dgSlider('reset');
        $('#sldSymmetry').dgSlider('reset');
        $('#sldPolish').dgSlider('reset');

        $('#sldTable').dgSlider('reset');
        $('#sldDepth').dgSlider('reset');

        $("#fname").val('')
        $("#fname1").val('')
        $("#cname").val('')
        $("#cname1").val('')
      }
      else{
        $('#idType li a, #idMetal li a').removeClass('active');
        $('#idType li a, #idMetal li a').addClass('active');
        $('#sldPrice').dgSlider('reset');
      }
      filterNow();
    });

    $('ul.metals a').click( function(e){
      e.preventDefault();

        $(this).parent().parent().find('.active').removeClass('active');
        $(this).addClass('active');
        $(this).parent().parent().parent().find('.rsimgs.active').removeClass('active');
        $(this).parent().parent().parent().find('.rsimg-' + $(this).attr('href') ).addClass('active');
var mp = currencyFormat( parseInt($(this).attr('data-price')), 2);

        var par = $(this).parent().parent().parent().parent();
        par.find('.thumbc.active').removeClass('active');
        par.find('.thumbc-' + $(this).attr('href') ).addClass('active');

        par.attr('data-metal',$(this).attr('href') );
        par.attr('data-click','x' );
        par.find('div.rdesc span').html( mp );
    });



    $('.thumbc a').mouseover( function(e){
      e.preventDefault();

      var indexP = $(this).parent().parent().find('.active').parent().index();
      var indexN = $(this).parent().index();
      var par = $(this).parent().parent().parent().parent();
      var par2 = par.parent();

      par.find('.thumbc ').each( function(n,e){
        $(this).find('.active').removeClass('active');
        $(this).find('ul li:nth-child('+(indexN+1)+') a').addClass('active');
      });

      par2.find('.rsimgs').each( function(n,e){
        $(this).find('.active').removeClass('active');
        $(this).find('li:nth-child('+(indexN+1)+')').addClass('active');
      });
      par2.attr('data-click','x' );
    });

    $('.ring-box div.rbinner').click( function(e){
      e.preventDefault();
      var par = $(this).parent();
      if( par.attr('data-click') == "" ){

        window.location = par.attr('data-id') + '/' + par.attr('data-metal');
      }

      par.attr('data-click','');
    });

    windowResize();
    $(window).resize( windowResize );

});


function getGIARecentViews(){

  $('#rv-results .resulthere tbody').html("<tr><td colspan='8' class='mustshow'>Loading...</td></tr>");
  $('#rv-results').addClass('noexpand');
  $.post("/api/diamonds/recent",
  {
  },
  onGIARecentResultDone);

}

function filterNow( p = 1){
  if( $('.gia-diamond-filters').length > 0 ){
    if( $('.gia-diamond-filters').attr('data-filter-func') )
      eval( $('.gia-diamond-filters').attr('data-filter-func') )(p);
  }

}

// ringsetting page, result filter triggers - #SAI 20260618 to the rescue!

$(document).ready(function(){
    if($('.ringsetting-filter-now').length > 0){
        $('.ringsetting-filter-now').click(function(){
            filterNow();
        });
        $('#idType a,#idMetal a').click(function(){
            filterNow();
        });
        // slider update call filterNow()
        $('#sldPrice').dgSlider('update', function(){
            filterNow();
        });
        $('body').on('mouseup', function(){
            filterNow();
        });
    }
}); // ---- end

function giasettingFilterNow( p = 1 ){

  $('.ring-box').hide();
  var str = '';
  var arr = [];
  var arrx = [];
  $('#idType a.active').each( function(n,e){
    str = 'rt-' + $(this).attr('data-type');
    $('.ring-box.' + str).show();
  });

  $('.ring-box' ).each(function(n,e){

    if( $(this).is(':visible') ){
      arr.push( $(this).attr('data-count') );
    }
  });

  $('.ring-box').hide();

  $('#idMetal a.active').each( function(n,e){
    str = 'rm-' + $(this).attr('data-type');
    $('.ring-box.' + str).show();

  });

  $('.ring-box' ).each(function(n,e){

    if( $(this).is(':visible') ){
      for( var i=0; i<arr.length;i++ ){
        if( arr[i] == $(this).attr('data-count') ) {
          arrx.push( $(this) );
        }
      }
    }
  });

  var arange = $('#sldPrice').dgSlider('val');
  arange[0] = parseFloat(arange[0]);
  arange[1] = parseFloat(arange[1]);

  $('.ring-box').hide();
  for( var i=0; i<arrx.length;i++ ){
    var mprice = parseFloat(arrx[i].attr('data-price'));
    if( mprice >= arange[0] && mprice <= arange[1] ) arrx[i].show();
  }
}

function giaFilterNow( p = 1){

  if( !$('.gia-diamond-filters').hasClass('ring-setting') ){

  $('.filter-panel').addClass('dis');

  if( p == 1 ){
    $('#ft-results .resulthere tbody').html("<tr><td colspan='8' class='mustshow'>Loading...</td></tr>");
    $('.gia-results .tabs ul li:nth-child(2) span').html("");
    $('.gia-results .tabs ul li:nth-child(1) span').html("");
    $('#cp-results .resulthere tbody').html('<tr><td colspan="8" class="mustshow">No record(s)</td></tr>');
    $('#cp-results').removeClass('noexpand');
    $('#cp-results').addClass('noexpand');
    $('#ft-results').addClass('noexpand');
  }

    var shapes = '';
    $('#idShape li a.active').each( function(n,e){
      shapes += $(this).attr('href') + ",";
    });


    var sortval = $('#ft-results .headonly thead .sortfield.active').attr('data-val');

    var sortdir = 0;
    if( $('#ft-results .headonly thead .sortfield.active').hasClass('up') ) sortdir = 1;

    $("#ft-results").attr("data-loading",1);
    $("#ft-results").attr("data-cpage", p);
//return;
    $.post("/api/diamonds",
    {
      shapes: shapes,
      cuts: $('#sldCut').dgSlider('val'),
      clarities: $('#sldClarity').dgSlider('val'),// $('select[name="clarity"]').val(),
      colors: $('#sldColor').dgSlider('val'),
      fluorescences: $('#sldFluorescence').dgSlider('val'),
      symmetries: $('#sldSymmetry').dgSlider('val'),
      table: $('#sldTable').dgSlider('val'),
      depth: $('#sldDepth').dgSlider('val'),
      size: $('#sldSize').dgSlider('val'),
      polish: $('#sldPolish').dgSlider('val'),
      price: $('#sldPrice').dgSlider('val'),
      page: p,
      sortby: sortval,
      sortdir: sortdir
    },
    onGIAResultDone);
  }
  else{

  }


}

function onGIARecentResultDone(data, status){
  var t = data.list.length;
      var i;
      var html = "";
      var tpage = Math.ceil(data.total / data.psize);

      for( i=0; i<t; i++ ){

        var img = "";
        var vid = "";

        if( data.list[i].img != "" ){
          img += "<i class=\"fas fa-image\"></i>";
        }
        if( data.list[i].vid != "" ){
          vid += "<i class=\"fas fa-video\"></i>";
        }
        var shape2 = data.list[i].shape.toLowerCase();
        var shape = '';

        var ii = 0;
        for( ii=0; ii<shape2.length; ii++ ){

          if( ii == 0 )
            shape += shape2[ii].toUpperCase();
          else
            shape += shape2[ii];
        }

        html += "<tr data-ref='"+data.list[i].ref+"' data-img='"+data.list[i].img+"' data-vid='"+data.list[i].vid+"' >";
        html += "<td>&nbsp;</td>";
        html += "<td><i class='icoDiamond"+shape+"' ></i><span>"+shape+"</span></td>";
        html += "<td><span>"+data.currency+" </span>"+data.list[i].price+"</td>";
        html += "<td>"+data.list[i].size+"</td>";
        html += "<td>"+data.list[i].color+"</td>";
        html += "<td>"+data.list[i].clarity+"</td>";
        html += "<td>"+data.list[i].cut+"</td>";

        //if( i == 0)
        //html += "<td rowspan='"+t+"' id='preview-area'></td>";
        html += "<td></td>";
        html += "</tr>";
      }
      if( html == "" ) html = '<tr><td colspan="8" class="mustshow">No record(s)</td></tr>';
      else{
        $('#rv-results').removeClass('noexpand');
      }
      $('#rv-results .resulthere tbody').html( html ) ;
      //$('#rv-results .resulthere tbody tr').off( "click", giarowclick);
      //$('#rv-results .resulthere tbody tr').on( "click", giarowclick);

      sortCompareBox('#rv-results');
/*
      $('.pagingn a').click( function(e){
        e.preventDefault();

        if( $(this).attr('href') == 0 ) return;
        filterNow( $(this).attr('href') );
      });
      */


      $('#rv-results table.gia-d tr').click(function(e){
        e.preventDefault();
      });

      $('.filter-panel').removeClass('dis');

      $('#rv-results .resulthere tbody tr').off('click', function(e){
        e.preventDefault();
        if( $(window).innerWidth() < 500 ){
          window.location = '/gia-diamonds/' + $(this).attr('data-ref');
        }
      });
      $('#rv-results .resulthere tbody tr').on('click', function(e){
        e.preventDefault();

        if( $(window).innerWidth() < 500 ){
          window.location = '/gia-diamonds/' + $(this).attr('data-ref');
        }
      });
}

function onGIAResultDone(data, status){

    trace(location.hostname, 'diamond', data);

    if(data.response == 0){
        $('#ft-results .resulthere tbody').html( '<tr><td colspan="8"  class="mustshow">Diamond list could not be loaded, Please try again.</td></tr>' ) ;
        return false;
    }

  var t = data.list.length;
      var i;
      var html = "";
      var tpage = Math.ceil(data.total / data.psize);
      $("#ft-results").attr("data-pages",tpage);


      for( i=0; i<t; i++ ){

        var img = "";
        var vid = "";

        if( data.list[i].img != "" ){
          img += "<i class=\"fas fa-image\"></i>";
        }
        if( data.list[i].vid != "" ){
          vid += "<i class=\"fas fa-video\"></i>";
        }
        var shape2 = data.list[i].shape.toLowerCase();
        var shape = '';

        var ii = 0;
        for( ii=0; ii<shape2.length; ii++ ){

          if( ii == 0 )
            shape += shape2[ii].toUpperCase();
          else
            shape += shape2[ii];
        }


        html += "<tr data-ref='"+data.list[i].ref+"' data-img='"+data.list[i].img+"' data-vid='"+data.list[i].vid+"' >";
        html += "<td><a href='#' class='comparebox'><i></i></a></td>";
        html += "<td><i class='icoDiamond"+shape+"' ></i><span>"+shape+"</span></td>";
        //html += "<td><span>"+data.currency+" </span>"+data.list[i].price+" <small style='font-size:.8em;'>"+data.list[i].ref+"</small></td>";
        html += "<td><span>"+data.currency+" </span>"+data.list[i].price+"</td>";
        html += "<td>"+data.list[i].size+"</td>";
        html += "<td>"+data.list[i].color+"</td>";
        html += "<td>"+data.list[i].clarity+"</td>";
        html += "<td>"+data.list[i].cut+"</td>";

        //if( i == 0)
        //html += "<td rowspan='"+t+"' id='preview-area'></td>";
        //html += "<td></td>";
        html += "</tr>";
      }

      if( data.cpage == 1 ) {
        if( html == "" ) html = '<tr><td colspan="8"  class="mustshow">No record(s)</td></tr>';
        else{
          $('#ft-results').removeClass('noexpand');
        }
        $('#ft-results .resulthere tbody').html( html ) ;
      }else
        $('#ft-results .resulthere tbody').append( html ) ;


      $('#ft-results .resulthere tbody tr').off( "click", giarowclick);
      $('#ft-results .resulthere tbody tr').on( "click", giarowclick);


      //console.log('ssssss', data);
      //diamond_list_total+=data.total;
      diamond_list_total = $('#ft-results .resulthere tbody tr').length;

      if( $('.gia-results .tabs ul li:first-child a span').length == 0 ){
        $('.gia-results .tabs ul li:first-child a').append('<span>('+diamond_list_total+')</span>');
      }
      else
      $('.gia-results .tabs ul li:first-child a span').html('('+data.total+')');

      $('#ft-results .resulthere tbody tr').off('click', function(e){
        e.preventDefault();
        if( $(window).innerWidth() < 500 ){
          window.location = '/gia-diamonds/' + $(this).attr('data-ref');
        }
      });
      $('#ft-results .resulthere tbody tr').on('click', function(e){
        e.preventDefault();

        if( $(window).innerWidth() < 500 ){
          window.location = '/gia-diamonds/' + $(this).attr('data-ref');
        }
      });




      $('#ft-results .pagingn a').click( function(e){
        e.preventDefault();

        if( $(this).attr('href') == 0 ) return;
        filterNow( $(this).attr('href') );
      });


      $('#ft-results table.gia-d tr').click(function(e){
        e.preventDefault();
      });


      $("#ft-results").attr("data-loading",0);
      $('.filter-panel').removeClass('dis');
}

jQuery.fn.extend({

  dgSlider: function( d = "" ){

    if( d == "reset" ){
      var val = $(this).attr('data-val').split(",");
      var step = $(this).attr('data-step');
      $(this).find('a.drg2').css('left','8px');
      $(this).find('a.drg2').attr('data-m','0');
      $(this).find('a.drg1').attr('data-m', val.length);
      $(this).find('a.drg1').css('left','calc( 100% - 8px)');
      dgSliderUpdate(this);


      if( $(this).attr('data-type') == "number" ){
        $(this).find('a.drg1').attr('data-m', val[1] / step);

        $(this).find('.minv span').html(val[0]);
        $(this).find('.maxv span').html(val[1]);
      }


    }
    else if( d == "val" ){

      var a = [];

      if( $(this).attr('data-type') == "label" ){

        $(this).find('ul li.sel').each( function(n,e){
          var str = $(this).html();

          if( str == "V.Strong" )str = "Very Strong";
          if( $(window).innerWidth() > 500 ){

            if( str == "Excellent" )str = "EX";
            else if( str == "Very Good" )str = "VG";
            else if( str == "Good" )str = "G";
          }

            a.push(str);
        });
      }else{

        if($(this).attr('id')=='sldPrice' || $(this).attr('id') == 'sldSize'){
            var minv = $(this).find('.info .minv span').html().replace(/,/g, '');
            var maxv = $(this).find('.info .maxv span').html().replace(/,/g, '');
            a.push( minv );
            a.push( maxv );
        }


      }
      return a;
    }
    else if( d == "" && $(this).find('ul').length == 0 ){
      var arr = $(this).attr('data-val').split(",");
      var html = '';


    if( $(this).attr('data-type') == "label" ){
      html = '<div class="dg-bg"><div class="bar"></div><div class="bar2"></div>';
      html += '<ul>';
      for( var i=0; i<arr.length; i++ ){
        var str = arr[i];

        if( str == "Very Strong" ) str = "V.Strong";
        if( $(window).innerWidth() > 500 ){

          if( str == "VG" ) str = "Very Good";
          else if( str == "G" && $(this).attr('id') != 'sldColor' ) str = "Good";
          else if( str == "EX" ) str = "Excellent";
        }


        html += '<li>' + str + '</li>';
      }
      html += '</ul>';
    }
    else{
      html = '<div class="dg-bg dg-bg-slim"><div class="bar"></div><div class="bar2"></div>';
    }
    html += '</div>';


      $(this).append(html);
//console.log($(this).find('ul li').length);
var step = parseFloat($(this).attr('data-step'));
    var c,axc, m = 0;
    if( $(this).attr('data-type') == "label" ) c = $(this).find('ul li').length;
    else {
      axc = $(this).attr('data-val').split(',');
      c = axc[1] - axc[0];// - axc[0];
      c = c / step;
      m = 0;//axc[0];
    }




      $(this).append('<a href="#" class="dragg drg1" style="left: calc(100% - 8px);" data-m="'+c+'"><i class="dgs-left"></i></a>');
      $(this).append('<a href="#" class="dragg drg2" style="left: 8px;" data-m="'+m+'"><i class="dgs-right"></i></a>');

      if( $(this).attr('data-type') == "label" ) {
        $(this).append('<div class="info"></div>');
      }else{

        var prefix = $(this).attr('data-prefix').split(',');
        var prefix2 = $(this).attr('data-prefix2').split(',');
        $(this).append('<div class="info"><div class="minv">'+prefix[0]+'<span>'+axc[0]+'</span>'+prefix2[0]+'</div><div class="maxv">'+prefix[1]+'<span>'+axc[1]+'</span>'+prefix2[1]+'</div></div>');
      }

      $(this).find('a').on( "mousedown touchstart", function(e){
        e.preventDefault();
        if( _onmdown ) return;

        if( !e.offsetX ) {
          _mmstart = e.originalEvent.changedTouches[0].pageX;

          console.log(_mmstart);
        }

        _onmdown = true;
        _mdownobj = $(this);
        $(this).parent().find('.dragg').removeClass('act');;
        _mdownobj.addClass('act');
      });

      $(window).on('mouseup touchend', function(e){
        if( !_onmdown ) return;


        _onmdown = false;
        _mdownobj.parent().find('.dis').removeClass('dis');
        var ox = _mdownobj.css('left');

        ox = parseFloat( ox.substr(0,ox.length-2) );
        dgSliderUpState(_mdownobj.parent(), ox);
        _mdownobj = null;
      });

      $(this).on( 'mousemove touchmove', function(e){


        if( !_onmdown )  return;


        if( $(e.target).hasClass('dragg') && e.offsetX ) return;
        $(this).find('a.dragg').addClass('dis');

        var par = $(this);



        if( e.offsetX ) {
          dgSliderUpState(par,e.offsetX, false);
        }
      else{

        let r = e.currentTarget.getBoundingClientRect();
var ofx = e.originalEvent.changedTouches[0].clientX - r.left;
        dgSliderUpState(par, ofx, false);
      }

        //dgSliderUpState(par,e.offsetX, false);

      }).on( 'mouseup touchend', function(e){
        e.preventDefault();
        if( !_mdownobj ) return;
        var par = $(this);

        if( e.offsetX )
          dgSliderUpState(par,e.offsetX, true);
        else{
          let r = e.currentTarget.getBoundingClientRect();
          var ofx = e.originalEvent.changedTouches[0].clientX - r.left;
          dgSliderUpState(par,ofx, true);
        }
      });

      dgSliderUpdate(this);
    }


  }
});

function dgSliderUpState( par,eox, ttx ){
  $("#fname").val(document.getElementsByClassName('dragg drg1')[0].getAttribute("data-m")*100)
  $("#fname1").val(document.getElementsByClassName('dragg drg2')[0].getAttribute("data-m")*100)
  $("#cname").val($('#sldSize').dgSlider('val')[1])
  if ($('#sldSize').dgSlider('val')[1] > 5) {
    $("#cname").val(5)
  }
  $("#cname1").val($('#sldSize').dgSlider('val')[0])
  var dobj = _mdownobj;
  var c,tp,px,i,t2a,t2b,t3a,t3b;
  var step = parseFloat(par.attr('data-step'));

  if( par.attr('data-type') == "label" ){
    c = par.find('ul li').length;
  }else{
    var arr = par.attr('data-val').split(",");
    c = arr[1] - arr[0];
    c = c / step;
  }


  var sliderw = par.find('.dg-bg').innerWidth();
  var ox = eox - 8;
  if( ox < 0 ) ox = 0;
  if( ox > sliderw  - 16 ) ox = sliderw - 16;

  tp = 1 / c;
  px = ox / (sliderw-16);

  i = 0;
  while( px > tp *  (i+1) ){ i++; }

  t2a = (tp * i);
  t2b = (tp * (i+1) );
  t3a = Math.abs(t2a - px);
  t3b = Math.abs(t2b - px);
  if( t3a > t3b ) i++;

  ox = (tp * i) * (sliderw - 16) + 8;

  var m;
  if( _mdownobj.hasClass('drg1') ){
    m = parseFloat(_mdownobj.parent().find('.drg2').attr('data-m'));
    var ox2 = _mdownobj.parent().find('.drg2').css('left');
    ox2 = parseFloat(ox2.substr(0, ox2.length - 2));
    if( m >= i && _mdownobj.parent().attr('data-type') == "label" ){i = m + 1;ox = (tp * i) * (sliderw - 16) + 8;}
    else if( ox < ox2 ) ox = ox2 ;

    if( m >= i && _mdownobj.parent().attr('data-type') != "label" ) {i = m;}

  }else{
    m = parseFloat(_mdownobj.parent().find('.drg1').attr('data-m'));
    var ox2 = _mdownobj.parent().find('.drg1').css('left');
    ox2 = parseFloat(ox2.substr(0, ox2.length - 2));

    if( m <= i && _mdownobj.parent().attr('data-type') == "label"  ){i = m - 1;ox = (tp * i) * (sliderw - 16) + 8;}
    else if( ox > ox2 ) ox = ox2 ;

    if( m <= i && _mdownobj.parent().attr('data-type') != "label"  ){ i = m;}
  }

  var xxperc = ((ox) / sliderw) * 100;
  dobj.css('left', "calc(" + xxperc + "% )");
  dobj.attr('data-m',i);


  if( ttx ) par.find('a.dragg').removeClass('dis');
  dgSliderUpdate(dobj.parent());


//   clearTimeout(_filtersec);
//   _filtersec = setTimeout( filterNow, 500 );
}

function dgSliderUpdate( objthis ){

  var step = parseFloat(objthis.attr('data-step'));
  var min = parseFloat(objthis.find('a.drg2').attr('data-m')) * step;
  var max = parseFloat(objthis.find('a.drg1').attr('data-m')) * step;

  var str = "";

  var minx = objthis.find('a.drg2').css('left');
  var maxx = objthis.find('a.drg1').css('left');

  minx = parseFloat(minx.substr(0, minx.length - 2) );
  maxx = parseFloat(maxx.substr(0, maxx.length - 2) );

  var bgw = objthis.find('.dg-bg').innerWidth();

  var diff = maxx - minx;

  //diff = diff / step;
  var wp = diff / bgw * 100;
  var minxp = minx / bgw * 100;

  objthis.find('.bar2').css('width', "calc(" + wp + '%)');
  objthis.find('.bar2').css('left', minxp + '%');

  if( objthis.attr('data-type') == "label" ){

    var str = '';
    objthis.find('ul li').removeClass('sel');
    objthis.find('ul li').each( function(n,e){
      if( n >= min && n < max ) {
        $(this).addClass('sel');

        //str += $(this).html() + ',';
      }
    });

    //str = str.substr(0,str.length - 1);
    //objthis.find('.info').html(str);

    //console.log(str);

  }else{

    var arr = objthis.attr('data-val').split(",");
    var gmin = parseFloat(arr[0]) + min;
    var gmax = parseFloat(arr[0]) + max;

var f = parseInt( objthis.attr('data-decimal') );


    objthis.find('.info .minv span').html( currencyFormat(gmin,f) );
    objthis.find('.info .maxv span').html( currencyFormat(gmax,f) );
  }
}


function currencyFormat(num,d) {
  return num.toFixed(d).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}



function giarowclick(e){

  if( $(e.target).hasClass('comparebox') )  {
    e.preventDefault();


    var par = $(this).parent().parent().parent().parent().parent().parent();

    if( par.attr('id') == "ft-results" ){
      var bt = $('#ft-results a.comparebox.checked').length;

      $(e.target).toggleClass('checked');

      var t = $('#ft-results a.comparebox.checked').length;

      if( t == 0 ){
        $('.gia-results .tabs ul li:nth-child(2) span').html("");
      }else{
        $('.gia-results .tabs ul li:nth-child(2) span').html("("+t+")");
      }

      var ref = $(this).attr('data-ref');
      if( $(e.target).hasClass('checked') ){
        if( bt == 0 ){
          $('#cp-results .resulthere tbody').html('');
        }
        $('#cp-results .resulthere tbody').append( "<tr data-ref='"+ref+"' data-img='"+$(this).attr('data-img')+"' data-vid='"+$(this).attr('data-vid')+"' >"+$(this).html()+"</tr>" );
        $('#cp-results').removeClass('noexpand');

        $('.gia-results tbody tr').off( "click", giarowclick);
        $('.gia-results tbody tr').on( "click", giarowclick);

        $('#cp-results .resulthere tbody tr td:nth-child(8)').remove();
        //$('#cp-results .resulthere tbody tr:first-child').append("<td rowspan='"+t+"' id='preview-area'></td>");
        sortCompareBox('#cp-results');

      }else{
        $('#cp-results .resulthere tbody tr[data-ref="'+ref+'"]').remove();
        $('#cp-results').removeClass('noexpand');
        if( t == 0 ) {
          $('#cp-results .resulthere tbody').html('<tr><td colspan="8" class="mustshow">No record(s)</td></tr>');
          $('#cp-results').addClass('noexpand');
        }
      }
    }else{

      var ref = $(this).attr('data-ref');
      if( $(e.target).hasClass('checked') ){
        $('#cp-results .resulthere tbody tr[data-ref="'+ref+'"]').remove();

        $('#ft-results .resulthere tbody tr[data-ref="'+ref+'"] a.comparebox').removeClass('checked');


        var t = $('#cp-results a.comparebox.checked').length;
        $('.gia-results .tabs ul li:nth-child(2) span').html("("+t+")");
        if( t == 0 ) {
          $('.gia-results .tabs ul li:nth-child(2) span').html("");
          $('#cp-results .resulthere tbody').html('<tr><td colspan="8" class="mustshow">No record(s)</td></tr>');

          $('#cp-results').removeClass('noexpand');
            $('#cp-results').addClass('noexpand');
        }else{
          $('.gia-results .tabs ul li:nth-child(2) span').html("("+t+")");
        }
      }
    }

  }else if( $(e.target).hasClass('btndg') )  {

    //console.log('xxx');

  }else if( $(e.target).attr('id') == "preview-area" )  {

    e.preventDefault();

  }else{
    e.preventDefault();
    var par = $(this).parent().parent().parent().parent().parent();


    par.find('.resulthere .active').removeClass('active');
    $(this).addClass('active');

    if( $(this).attr('data-img') != "" ){
      par.find('.preview-area-table').html("<div><img src='"+$(this).attr('data-img')+"' alt='' /></div>");
    }
    else{
      par.find('.preview-area-table').html('<div class="noimage">No image.</div>');
    }
    par.find('.preview-area-table').append("<div style='font-size:.7em;'>Diamond Ref.: "+$(this).attr('data-ref')+"</div>");
    par.find('.preview-area-table').append("<div style='font-size:.7em;font-weight:bold; display:none' class='checking-diamond'>Querying diamond status...</div>");
    par.find('.preview-area-table').append("<a href='/gia-diamonds/" + $(this).attr('data-ref') + "' class='btndg view-diamond-btn'>View Diamond</a>");
    par.find('.preview-area-table').append("<div style='color:red; display:none' class='diamond-unavailable'>Diamond unavailable.</div>");
    requiryDiamondStatus($(this).attr('data-ref'));
  }
}

function requiryDiamondStatus(ref){
    $('.view-diamond-btn').hide();
    $('.checking-diamond').show();
    $.get('/api/diamonds/requery/'+ref, function(r){
        //trace('requery result:');
        //console.log(r, r.status);
        if(r.status=='ok'){
            $('.view-diamond-btn').show();
        } else {
            $('.diamond-unavailable').show();
        }
        $('.checking-diamond').hide();

    });
}



function validateEmail(sEmail) {
  var filter = /^[\w\-\.\+]+\@[a-zA-Z0-9\.\-]+\.[a-zA-z0-9]{2,4}$/;
  if (filter.test(sEmail)) return true;
  else return false;
}


function sortCompareBox(strx){
  var arr = [];
  $(strx + ' .resulthere tbody tr').each( function(n,e){

    var shape = $(this).find('td:nth-child(2) span').html();
    var price = $(this).find('td:nth-child(3)').html();
    var index = price.indexOf("</span>") + 7;
    price = parseFloat( price.substr(index).replace(/,/g, '') );
    var size = parseFloat($(this).find('td:nth-child(4)').html());
    var color = $(this).find('td:nth-child(5)').html();
    var clarity = $(this).find('td:nth-child(6)').html();
    var cut = $(this).find('td:nth-child(7)').html();
    arr.push( [ $(this).attr('data-ref'), $(this).attr('data-img'), $(this).attr('data-vid'), $(this).html()
    ,shape,price,size,color,clarity,cut
  ] );
  });

    var indexx = $(strx +' .headonly thead a.active').parent().index();
    var sortdir = 0;
    if( $(strx +' .headonly thead a.active').hasClass('up') )sortdir = 1;
  arr.sort(function(a, b) {
    var keyA = a[indexx + 3],
      keyB = b[indexx + 3];

      if( sortdir == 1 ){
    if (keyA < keyB) return -1;
    if (keyA > keyB) return 1;
      }else{

        if (keyA < keyB) return 1;
        if (keyA > keyB) return -1;
      }
    return 0;
  });

  $(strx +' .resulthere tbody tr').remove();

  for( var i=0; i<arr.length; i++ ){
    $(strx +' .resulthere tbody').append( "<tr data-ref='"+arr[i][0]+"' data-img='"+arr[i][1]+"' data-vid='"+arr[i][2]+"' >"+arr[i][3]+"</tr>" );
  }

  $('.gia-results '+strx+' .resulthere tbody tr').off( "click", giarowclick);
  $('.gia-results '+strx+' .resulthere tbody tr').on( "click", giarowclick);

}
$("#fname1").change(function (e) {
  let max = `${($("#fname").val() / 1000000) * 100}` == 0 ? '100%' : `${($("#fname").val() / 1000000) * 100}%`
  let min = `calc(${($("#fname1").val() / 1000000) * 100}%)`
  document.getElementsByClassName('dragg drg2')[0].setAttribute("data-m", $("#fname1").val()/100);
  document.getElementsByClassName('dragg drg2')[0].style.left = `${min}`;
  document.getElementsByClassName('bar2')[0].style.left = `${min}`;
  document.getElementsByClassName('bar2')[0].style.width = `calc(${max} - ${($("#fname1").val() / 1000000) * 100}% - 8px)`;
  document.getElementsByClassName('minv')[0].children[0].innerHTML = $("#fname1").val()
  //giaFilterNow()
});

$("#fname").change(function (e) {
  let max = `${($("#fname").val() / 1000000) * 100}%`
  document.getElementsByClassName('dragg drg1')[0].style.left = `calc(${max} - 8px)`;
  document.getElementsByClassName('dragg drg1')[0].setAttribute("data-m", $("#fname").val()/100);
  document.getElementsByClassName('bar2')[0].style.width = `calc(${max} - calc(${($("#fname1").val() / 1000000) * 100}%) - 8px)`;
  document.getElementsByClassName('maxv')[0].children[0].innerHTML = $("#fname").val()
  //giaFilterNow()
});

$("#cname1").change(function (e) {
  let cname1Min = Number($("#cname1").val()).toFixed(2)
  $("#cname1").val(cname1Min)
  if (cname1Min <= 0.3 || cname1Min >= 5 ) {
    $("#cname1").val(0.3);
    cname1Min = 0.3;
  }
  if (cname1Min => 0.3 && cname1Min <= 5 ) {
    let max = `${($("#cname").val() / 5) * 100}` == 0 ? '100%' : `${($("#cname").val() / 5) * 100}%`
    let min = `calc(${(cname1Min / 5) * 100}%)`
    document.getElementsByClassName('dragg drg2')[1].setAttribute("data-m", parseInt(cname1Min/5*50 - 3));
    document.getElementsByClassName('dragg drg2')[1].style.left = `${min}`;
    document.getElementsByClassName('bar2')[1].style.left = `${min}`;
    document.getElementsByClassName('bar2')[1].style.width = `calc(${max} - ${(cname1Min / 5) * 100}% - 8px)`;
    document.getElementsByClassName('minv')[1].children[0].innerHTML = cname1Min
    //giaFilterNow()
  }
});

$("#cname").change(function (e) {
  let cnameMax = Number($("#cname").val()).toFixed(2)
  let cname1Min = Number($("#cname1").val()).toFixed(2)
  $("#cname").val(cnameMax)
  if (cnameMax < 0.3 || cnameMax >= 5 ) {
    $("#cname").val(5.0);
    cnameMax = 5;
  }
  if (cnameMax > 0.3 && cnameMax <= 5 ) {
  let max = `${($("#cname").val() / 5) * 100}%`
  let min = `calc(${(cname1Min / 5) * 100}%)`
  document.getElementsByClassName('dragg drg1')[1].style.left = `calc(${max})`;
  document.getElementsByClassName('dragg drg1')[1].setAttribute("data-m", parseInt(cnameMax/5*50 - 3));
  document.getElementsByClassName('bar2')[1].style.width = `calc(${max} - calc(${Math.ceil(($("#cname1").val() / 5) * 100)}%) + 2.3%)`;
  document.getElementsByClassName('maxv')[1].children[0].innerHTML = cnameMax
  //giaFilterNow()
  }
});

$('#btn-apply-diamond-filer').click(function(){
    giaFilterNow(1);
});
setTimeout(() => {
    $('#btn-apply-diamond-filer').trigger('click');
}, 1000);

